import { TabMenuItem } from '@/ux/TabMenu/TabMenu'

export const LOGGED_OUT_MENU: TabMenuItem[] = [
  {
    key: 'application_external',
    title: 'Applications',
  },
  {
    key: 'platform_external',
    title: 'Platform',
  },
]

export const SEARCH_STRING_MENU: TabMenuItem[] = [
  { key: 'all', title: 'All' },
  { key: 'live', title: 'Live' },
  { key: 'pending', title: 'Pending' },
  { key: 'developing', title: 'Developing' },
]

// ✅ Removed "Terminology"
export const PLATFORM_EXTERNAL_MENU: TabMenuItem[] = [
  { key: 'benefits', title: 'Benefits' },
  { key: 'our_edge', title: 'Our edge' },
  { key: 'get_started', title: 'Get started' },
  { key: 'get_in_touch', title: 'Get in touch' },
]
